module.exports = "/_next/static/images/SANTAI_ZURICH-d2547b9e4d2541916bb12bf9151d2300.svg";